import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },

  {
    path: "/home",
    component: (resolve) => require(["../views/home/home.vue"], resolve),
    meta: {
      keepAlive: true,
      requireAuth: false,
    },
  },
  {
    path: "/group",
    component: (resolve) => require(["../views/group/group.vue"], resolve),
    meta: {
      keepAlive: true,
      requireAuth: false,
    },
  },
  {
    path: "/targets",
    component: (resolve) => require(["../views/targets/targets.vue"], resolve),
    meta: {
      keepAlive: true,
      requireAuth: false,
    },
  },

];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.VUE_APP_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   // 需要权限校验
//   if (
//     localStorage.getItem("token") == null &&
//     to.path != "/login"
//   ) {
//     next("/login");

//     //console.log('lgoin', to)
//   }
//   next();
// });

export default router;
